import type { CountryCode } from '../PhonePrefix'
import phonePrefixes from './../phonePrefixes.json' assert { type: 'json' }

/**
 * Until online customer service does not persist phone country ISO, it is not possible
 * to autocomplete the right country flag with countries with the same prefix (USA, Canada...)
 * so the first found element is returned and showed.
 */
export const findCountryInfoByPhonePrefix = (
	prefix: string,
	countryISO: string
): CountryCode | undefined => {
	const { countryCodes } = phonePrefixes

	const countries = countryCodes.filter(
		(country) => country.phonePrefix === prefix
	)

	if (countries.length > 1) {
		return (
			countries.find((country) => country.countryIso === countryISO) ??
			countries[0]
		)
	}

	return countries[0]
}
